import { html, TemplateResult } from "lit";
import { customElement, property } from "lit/decorators.js";
import { searchQueryState } from "state/SearchQuery";
import { DodonaElement } from "components/meta/dodona_element";
import { i18n } from "i18n/i18n";

/**
 * This element represents a switch that can be toggled to affect the search
 *
 * @element d-switch-filter
 *
 * @prop {string} param - the searchQuery param to be used for this filter
 * @prop {boolean} default - whether this switch is enabled when the param is absent
 */
@customElement("d-switch-filter")
export class SwitchFilter extends DodonaElement {
    @property({ type: String })
    param: string;

    @property({ type: Boolean })
    default: boolean;

    render(): TemplateResult {
        return html`
            <div class="switch-filter">
                <div class="token token-bordered">
                    <input
                        type="checkbox"
                        id="${this.param}-filter"
                        .checked=${this.isEnabled()}
                        @change=${() => this.toggle()}
                    />
                    <label for="${this.param}-filter">${i18n.t(`js.search.filter.${this.param}`)}</label>
                </div>
            </div>
        `;
    }

    private isEnabled(): boolean {
        return searchQueryState.queryParams.has(this.param)
            ? searchQueryState.queryParams.get(this.param) == "true"
            : this.default;
    }

    private toggle(): void {
        searchQueryState.queryParams.set(this.param, (!this.isEnabled()).toString());
    }
}
